function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.7681 323.846C41.7681 329.077 46.052 333.359 51.2884 333.359H566.15C571.387 333.359 575.671 329.077 575.671 323.846L579.955 27.97C579.955 22.7386 573.791 12.5263 562.496 13.2934L59.3148 0.273715C52.7448 0.103261 46.3904 2.63251 41.738 7.26987C37.0856 11.9072 34.5388 18.2491 34.6942 24.8116L41.7681 323.846Z",
  fill: "#0056D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.1673 314.719C51.1673 319.672 55.2206 323.726 60.1738 323.726H553.734C558.687 323.726 562.74 319.672 562.74 314.719L566.784 46.1185C566.307 29.9554 552.137 24.1449 543.547 24.4883L61.2943 11.5514C56.6795 11.4286 52.2151 13.2058 48.9464 16.467C45.6777 19.7282 43.8779 24.19 43.9957 28.8074L51.1673 314.719Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M557.407 187.116C557.407 187.116 557.395 187.116 557.387 187.116C556.658 187.106 556.076 186.507 556.086 185.775L556.404 163.992C556.414 163.27 557.004 162.691 557.723 162.691C557.73 162.691 557.735 162.691 557.735 162.691C558.472 162.701 559.054 163.3 559.041 164.032L558.723 185.815C558.716 186.537 558.127 187.116 557.407 187.116Z",
  fill: "#DCDCDC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M558.192 133.737C558.192 133.737 558.179 133.737 558.171 133.737C557.442 133.727 556.86 133.125 556.87 132.396L558.096 48.9658C558.074 44.0101 556.57 40.0546 553.624 37.232C548.13 31.968 539.404 32.2362 539.035 32.2538L384.897 28.1203C384.168 28.1027 383.594 27.4936 383.614 26.7667C383.634 26.0372 384.193 25.4181 384.97 25.4832L539.018 29.6167C539.975 29.5591 549.265 29.3987 555.454 35.327C558.936 38.6609 560.713 43.2556 560.738 48.9808L559.513 132.436C559.5 133.158 558.911 133.737 558.192 133.737Z",
  fill: "#DCDCDC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.41628 357.919H605.584C606.363 357.919 607 357.282 607 356.503V333.341C607 332.562 606.363 331.925 605.584 331.925H1.41628C0.636702 331.925 7.34754e-06 332.562 7.34754e-06 333.341V356.503C-0.00249933 357.28 0.636702 357.919 1.41628 357.919Z",
  fill: "#0056D2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.9633 110.232L91.9629 121.148L251.343 121.155L251.343 110.238L91.9633 110.232Z",
  fill: "#CAC9C9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M136.145 55.9457L136.145 66.8623L251.068 66.8668L251.069 55.9502L136.145 55.9457Z",
  fill: "#CAC9C9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M111.821 55.0746L111.82 65.9912L128.359 65.9919L128.36 55.0753L111.821 55.0746Z",
  fill: "#CAC9C9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M136.03 74.1942L136.029 85.1108L250.953 85.1153L250.953 74.1987L136.03 74.1942Z",
  fill: "#CAC9C9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M111.739 73.3232L111.738 84.2397L128.277 84.2404L128.278 73.3238L111.739 73.3232Z",
  fill: "#CAC9C9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M135.608 92.414L135.607 103.331L250.531 103.335L250.532 92.4185L135.608 92.414Z",
  fill: "#CAC9C9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M110.756 91.5409L110.756 102.458L127.295 102.458L127.295 91.5415L110.756 91.5409Z",
  fill: "#CAC9C9"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M91.2055 186.198L91.2051 197.114L250.585 197.12L250.585 186.204L91.2055 186.198Z",
  fill: "#CAC9C9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M135.391 131.914L135.391 142.831L250.314 142.835L250.315 131.918L135.391 131.914Z",
  fill: "#CAC9C9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M111.067 131.04L111.066 141.957L127.605 141.958L127.606 131.041L111.067 131.04Z",
  fill: "#CAC9C9"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M135.274 150.162L135.273 161.079L250.197 161.083L250.198 150.167L135.274 150.162Z",
  fill: "#CAC9C9"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M110.983 149.289L110.982 160.206L127.521 160.206L127.522 149.29L110.983 149.289Z",
  fill: "#CAC9C9"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M134.856 168.38L134.855 179.296L249.779 179.301L249.78 168.384L134.856 168.38Z",
  fill: "#CAC9C9"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M109.998 167.507L109.998 178.424L126.537 178.424L126.538 167.508L109.998 167.507Z",
  fill: "#CAC9C9"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M91.2074 262.066L91.207 272.983L250.587 272.989L250.587 262.072L91.2074 262.066Z",
  fill: "#CAC9C9"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M135.393 207.783L135.393 218.7L250.316 218.704L250.317 207.787L135.393 207.783Z",
  fill: "#CAC9C9"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M111.061 206.909L111.061 217.826L127.6 217.826L127.6 206.91L111.061 206.909Z",
  fill: "#CAC9C9"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M135.274 226.031L135.273 236.948L250.197 236.952L250.198 226.035L135.274 226.031Z",
  fill: "#CAC9C9"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M110.981 225.158L110.98 236.074L127.52 236.075L127.52 225.158L110.981 225.158Z",
  fill: "#CAC9C9"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M134.852 244.248L134.852 255.165L249.775 255.169L249.776 244.253L134.852 244.248Z",
  fill: "#CAC9C9"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M109.998 243.376L109.998 254.292L126.537 254.293L126.538 243.377L109.998 243.376Z",
  fill: "#CAC9C9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M136.145 281.857L136.145 292.773L251.068 292.778L251.069 281.861L136.145 281.857Z",
  fill: "#CAC9C9"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M111.821 280.986L111.82 291.903L128.359 291.903L128.36 280.987L111.821 280.986Z",
  fill: "#CAC9C9"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M135.235 300.106L135.234 311.022L250.158 311.027L250.159 300.11L135.235 300.106Z",
  fill: "#CAC9C9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M110.944 299.235L110.943 310.151L127.482 310.152L127.483 299.235L110.944 299.235Z",
  fill: "#CAC9C9"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M278.01 46L278.01 57.0645L464.138 57.0733L464.139 46.0089L278.01 46Z",
  fill: "#DCDCDC"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M278.01 270.097L278.01 281.162L432.308 281.169L432.309 270.104L278.01 270.097Z",
  fill: "#DCDCDC"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M278 288.784V299.851L376.124 299.854C376.124 293.742 372.963 288.787 369.063 288.787L278 288.784Z",
  fill: "#CFD2D7"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M266.063 315.594H266.241C267.069 315.594 267.74 314.922 267.74 314.095V30.6469C267.74 29.8197 267.069 29.1479 266.241 29.1479H266.063C265.236 29.1479 264.564 29.8197 264.564 30.6469V314.095C264.564 314.922 265.236 315.594 266.063 315.594Z",
  fill: "#CAC9C9"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 277.99,
  y: 65.9404,
  width: 256.684,
  height: 198.028,
  rx: 25,
  fill: "#DCDCDC"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M114.592 41.8022C113.608 41.3842 112.713 40.7912 111.953 40.0448C111.171 39.2983 110.567 38.4196 110.163 37.4321C109.716 36.4212 109.492 35.3676 109.492 34.2479C109.492 29.7455 113.25 26.0771 117.835 26.0771C119.132 26.0771 120.431 26.3843 121.571 26.9559C122.711 27.504 123.741 28.3614 124.501 29.3723L124.859 29.8117L122.466 31.5477L122.131 31.1084C121.126 29.769 119.56 28.9991 117.837 28.9991C114.885 28.9991 112.468 31.3494 112.468 34.2479C112.468 37.1698 114.883 39.5414 117.837 39.5414C119.538 39.5414 121.104 38.7736 122.131 37.4321L122.466 37.0141L124.838 38.7267L124.479 39.1661C123.697 40.1983 122.711 41.0109 121.549 41.5825C120.409 42.1541 119.134 42.4399 117.837 42.4399C116.719 42.4399 115.622 42.2202 114.592 41.8022Z",
  fill: "#0056D2"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M127.097 40.9024C126.092 39.8702 125.531 38.5308 125.531 37.1679C125.531 35.7837 126.089 34.4443 127.097 33.4334C128.127 32.4673 129.469 31.917 130.9 31.917C132.377 31.917 133.719 32.4651 134.679 33.4334C135.709 34.4443 136.267 35.7624 136.267 37.1679C136.267 38.5734 135.709 39.8915 134.679 40.9024C133.674 41.8899 132.331 42.4402 130.9 42.4402C129.515 42.4402 128.148 41.892 127.097 40.9024ZM128.172 37.1679C128.172 38.6843 129.402 39.9128 130.9 39.9128C132.421 39.9128 133.652 38.6822 133.652 37.1679C133.652 35.6515 132.423 34.423 130.9 34.423C129.402 34.423 128.172 35.6536 128.172 37.1679Z",
  fill: "#0056D2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M151.478 42.1986V36.8176C151.478 35.6531 150.472 34.6209 149.308 34.6209C148.1 34.6209 147.116 35.6318 147.116 36.8176V42.1986H144.321V36.8176C144.321 35.6318 143.337 34.6209 142.151 34.6209C140.965 34.6209 139.981 35.6531 139.981 36.8176V42.1986H137.186V32.1383H139.981V32.8634C140.674 32.1831 141.412 31.9399 142.151 31.9399C142.8 31.9399 143.448 32.0722 144.075 32.3345C144.657 32.599 145.194 32.9722 145.685 33.4329C145.685 33.4542 145.706 33.4542 145.73 33.4777C145.752 33.4564 145.752 33.4564 145.776 33.4329C146.245 32.9722 146.782 32.599 147.385 32.3345C148.011 32.07 148.66 31.9399 149.31 31.9399C150.63 31.9399 151.882 32.4454 152.822 33.3454C153.763 34.2903 154.275 35.5209 154.275 36.8155V42.1965H151.478V42.1986Z",
  fill: "#0056D2"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M164.652 33.4567C165.657 34.4676 166.218 35.7857 166.218 37.1677C166.218 38.5519 165.659 39.87 164.652 40.8788C163.646 41.8662 162.304 42.3952 160.873 42.3952C159.932 42.3952 159.083 42.0667 158.345 41.4077L158.232 41.3203V48.0407H155.525V32.1386H158.232V32.9299L158.345 32.8211C159.15 32.0533 160.067 31.9424 160.873 31.9424C162.282 31.9403 163.622 32.4692 164.652 33.4567ZM163.511 37.1677C163.511 35.7174 162.304 34.5103 160.873 34.5103C159.441 34.5103 158.234 35.7174 158.234 37.1677C158.234 38.5946 159.441 39.8252 160.873 39.8252C162.304 39.8252 163.511 38.5967 163.511 37.1677Z",
  fill: "#0056D2"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M167.229 42.1989V26.0771H170.137V42.1989H167.229Z",
  fill: "#0056D2"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M172.371 29.2396C172.371 28.779 172.549 28.3609 172.886 28.0538C173.22 27.7254 173.646 27.5483 174.115 27.5483C175.056 27.5483 175.837 28.3161 175.837 29.2396C175.837 30.1631 175.056 30.9309 174.115 30.9309C173.155 30.9309 172.371 30.161 172.371 29.2396ZM172.662 42.1985V32.1381H175.57V42.1985H172.662Z",
  fill: "#0056D2"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M178.703 40.8809C177.697 39.87 177.137 38.5519 177.137 37.1698C177.137 35.7857 177.695 34.4676 178.703 33.4588C179.708 32.4713 181.05 31.9424 182.482 31.9424C183.422 31.9424 184.271 32.2708 185.01 32.9299L185.123 33.0173V32.1386H187.829V42.199H185.123V41.4077L185.01 41.5165C184.204 42.2843 183.288 42.3952 182.482 42.3952C181.072 42.3952 179.73 41.8684 178.703 40.8809ZM179.843 37.1677C179.843 38.618 181.05 39.8252 182.482 39.8252C183.913 39.8252 185.121 38.618 185.121 37.1677C185.121 35.7409 183.913 34.5103 182.482 34.5103C181.05 34.5103 179.843 35.7409 179.843 37.1677Z",
  fill: "#0056D2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M196.844 42.1986V36.8176C196.844 35.6318 195.882 34.7083 194.674 34.7083C193.512 34.7083 192.504 35.6531 192.504 36.8176V42.1986H189.709V32.1383H192.504V32.8634C193.197 32.1831 193.936 31.9399 194.674 31.9399C196.016 31.9399 197.269 32.4454 198.208 33.3454C199.148 34.2903 199.661 35.5209 199.661 36.8155V42.1965H196.844V42.1986Z",
  fill: "#0056D2"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M205.32 42.1989C204.336 42.1989 203.419 41.8257 202.748 41.1666C202.055 40.4863 201.697 39.6076 201.697 38.6414V34.4676H200.266V32.2047H201.697V28.2505H204.357V32.2047H207.333V34.4676H204.357V38.5966C204.357 39.1448 204.851 39.6502 205.341 39.6502H207.287L208.002 42.1989H205.32Z",
  fill: "#0056D2"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M105.136 42.7469H109.617C109.947 42.7469 110.14 42.3907 109.949 42.1327L97.4751 25.1664C97.3991 25.0619 97.2753 25 97.1428 25H92.6619C92.3317 25 92.1384 25.3562 92.3295 25.6142L104.804 42.5806C104.877 42.6851 105.003 42.7469 105.136 42.7469Z",
  fill: "#0056D2"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M97.2808 42.8022H92.3416C92.0657 42.8022 91.9028 42.4951 92.0636 42.2733L98.2908 33.7016C98.3712 33.5907 98.5037 33.5225 98.6427 33.5225H103.367C103.714 33.5225 103.919 33.9021 103.719 34.1794L97.5567 42.6615C97.4937 42.751 97.3916 42.8022 97.2808 42.8022Z",
  fill: "#00E7C5"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M103.98 30.1128C105.22 30.1128 106.226 29.1254 106.226 27.9075C106.226 26.6895 105.22 25.7021 103.98 25.7021C102.74 25.7021 101.734 26.6895 101.734 27.9075C101.734 29.1254 102.74 30.1128 103.98 30.1128Z",
  fill: "#00E7C5"
});

var _ref49 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.652,
  cy: 166.508,
  rx: 156.793,
  ry: 157.218,
  fill: "#DBE6F8",
  fillOpacity: 0.3
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.652,
  cy: 166.971,
  rx: 127.049,
  ry: 126.836,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.652,
  cy: 166.971,
  rx: 127.049,
  ry: 126.836,
  fill: "#A5C8FB",
  fillOpacity: 0.19
});

var _ref52 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.652,
  cy: 166.971,
  rx: 127.049,
  ry: 126.836,
  fill: "#8295B5",
  fillOpacity: 0.23
});

var _ref53 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.44,
  cy: 166.759,
  rx: 97.9424,
  ry: 97.7299,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref54 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.44,
  cy: 166.759,
  rx: 97.9424,
  ry: 97.7299,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.44,
  cy: 166.759,
  rx: 97.9424,
  ry: 97.7299,
  fill: "#396FBE",
  fillOpacity: 0.41
});

var _ref56 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_416_59279)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.864,
  cy: 166.758,
  rx: 67.3487,
  ry: 67.5611,
  fill: "#C4DBFF",
  fillOpacity: 0.38
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.864,
  cy: 166.758,
  rx: 67.3487,
  ry: 67.5611,
  fill: "#C4DBFF",
  fillOpacity: 0.38
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.864,
  cy: 166.758,
  rx: 67.3487,
  ry: 67.5611,
  fill: "#B5D1F8"
}));

var _ref57 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.44,
  cy: 166.759,
  rx: 60.1252,
  ry: 60.3376,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.44,
  cy: 166.759,
  rx: 60.1252,
  ry: 60.3376,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.44,
  cy: 166.759,
  rx: 60.1252,
  ry: 60.3376,
  fill: "#0D4EAC"
});

var _ref60 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_416_59279)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M326.067 166.759C326.067 185.532 310.753 200.752 291.862 200.752C272.971 200.752 257.656 185.532 257.656 166.759C257.656 147.985 272.971 132.766 291.862 132.766C310.753 132.766 326.067 147.985 326.067 166.759ZM262.883 166.759C262.883 182.664 275.857 195.558 291.862 195.558C307.866 195.558 320.841 182.664 320.841 166.759C320.841 150.853 307.866 137.96 291.862 137.96C275.857 137.96 262.883 150.853 262.883 166.759Z",
  fill: "white"
}));

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M326.067 166.759C326.067 185.532 310.753 200.752 291.862 200.752C272.971 200.752 257.656 185.532 257.656 166.759C257.656 147.985 272.971 132.766 291.862 132.766C310.753 132.766 326.067 147.985 326.067 166.759ZM262.898 166.759C262.898 182.656 275.865 195.543 291.862 195.543C307.858 195.543 320.826 182.656 320.826 166.759C320.826 150.862 307.858 137.974 291.862 137.974C275.865 137.974 262.898 150.862 262.898 166.759Z",
  fill: "#082F67"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M279 167.3L286.794 175L304 158",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_416_59279",
  x: 194.516,
  y: 69.1973,
  width: 194.697,
  height: 195.122,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "effect1_foregroundBlur_416_59279"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_416_59279",
  x: 257.656,
  y: 132.766,
  width: 68.4102,
  height: 71.9858,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_416_59279"
})));

function SvgActivationSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 358,
    viewBox: "0 0 607 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationSuccess);
export default __webpack_public_path__ + "static/media/activation-success.fa407863.svg";
export { ForwardRef as ReactComponent };